export default "__VITE_ASSET__DOHnW_8d__"